var render = function render(_c,_vm){return _c('span',{staticClass:"login-link"},[_c('span',{staticClass:"question"},[_vm._v(" Já possui uma conta? ")]),_c('a',{staticClass:"redirect",attrs:{"href":_vm.props.loginUrl}},[_vm._v(" ENTRAR ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }